export const validations = {
    required: value => {
        if (!value) {
            return 'This field is required';
        }
        return true;
    },
    integer: (min = 0, max = 9999999) => value => {
        if (!value.match(/^\d+$/)) {
            return 'This field must be a number';
        }
        if (value < min) {
            return `This field must be greater than or equal to ${min}`;
        }
        if (value > max) {
            return `This field must be less than or equal to ${max}`;
        }
        return true;
    },
    float: (min, max) => value => {
        if (isNaN(value)) {
            return 'This field must be a number';
        }
        if (value < min) {
            return `This field must be greater than or equal to ${min}`;
        }
        if (value > max) {
            return `This field must be less than or equal to ${max}`;
        }
        return true;
    },
    boolean: value => {
        if (value !== 'true' && value !== 'false') {
            return 'This field must be a boolean';
        }
        return true;
    },
    string: (min = 0, max = 2048) => value => {
        if (value.length < min) {
            return `This field must be at least ${min} characters long`;
        }
        if (value.length > max) {
            return `This field must be at most ${max} characters long`;
        }
        return true;
    },
    email: value => {
        if (!value.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)) {
            return 'Invalid email';
        }
        if (value.length > 100) {
            return 'Email is too long';
        }

        return true;
    },
    phone: value => {
        if (!value.match(/^\d{10}$/)) {
            return 'Invalid phone number';
        }
        if (value.length > 10) {
            return 'Phone number is too long';
        }
        return true;
    },
    zip: value => {
        if (!value.match(/^\d{5}$/)) {
            return 'Invalid zip code';
        }
        if (value.length > 5) {
            return 'Zip code is too long';
        }
        return true;
    },
    serverSide: (bool, msg) => {
        if (!bool) {
            return msg;
        }
        return true;
    }
};
